import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { DropdownItems } from '~/chords/DropdownSingleSelect/components/DropdownItems';
import type { RadixUiProps } from '~/chords/DropdownSingleSelect/types';

interface DropdownNoOptionsAvailableProps extends RadixUiProps {
  labelText?: string;
  labelNode?: ReactNode;
}

export function DropdownNoOptionsAvailable({
  labelText,
  labelNode,
  radix = {},
}: DropdownNoOptionsAvailableProps) {
  const { t } = useTranslation('common');

  return (
    <DropdownItems
      options={[
        {
          value: 'none',
          label: labelText || t('dropdownTree.noOptions'),
          isVisible: true,
          isSelected: false,
          optionIndex: 0,
        },
      ]}
      showCheckIcon={false}
      OptionTemplate={({ option }) => labelNode || option.label}
      radix={{
        ...radix,
        selectItem: {
          ...radix.selectItem,
          disabled: true,
          value: 'none',
          className: 'pointer-events-none',
        },
      }}
    />
  );
}

DropdownNoOptionsAvailable.displayName = 'DropdownNoOptionsAvailable';
